import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import GlobalStore from '../../stores/global-store';
import dashboardApi from '../../apis/dashboard-api';
import FilterDate from '../../components/FilterDate/FilterDate';
import CardHome from '../../components/Cards/CardHome';
import { storageGetItem } from '../../utils/local-storage';
import { USER_PROFILE } from '../../utils/storage-keys';
import './Home.css';
import { ExportToExcel } from '../../components/ExportToExcel/ExportToExcel';

function Home() {
  const { setLoading, affID } = GlobalStore.useContainer();
  const [isLeader, setIsLeader] = useState(false);
  const [dataPayout, setDataPayout] = useState({});
  const [dataPayoutFiltered, setDataPayoutFiltered] = useState({});
  const [dataDashboard, setDataDashboard] = useState({});
  const [dataDashboardFiltered, setDataDashboardFiltered] = useState({});
  const [dataVisits, setDataVisits] = useState([]);
  const [dataVisitsFiltered, setDataVisitsFiltered] = useState([]);
  const [referralsCounting, setReferralsCounting] = useState({
    conversionRate: 0,
    unpaidReferrals: 0,
    paidReferrals: 0,
    isConverted: 0,
    expectedRevenue: 0,
    actualRevenue: 0,
    commissionRevenue: 0,
    actualCommission: 0,
    paidEarnings: 0,
    unPaidEarning: 0,
    visits: 0,
    referralsSucceed: 0
  });
  const [filterDate, setFilterDate] = useState({
    label: 'Tất cả',
    slug: 'all',
    range: {}
  });

  const userProfile = JSON.parse(storageGetItem(USER_PROFILE));

  const calcRevenuePercent = useCallback((contractType, month) => {
    switch (contractType) {
      case 'direct':
        if (isLeader && month > 30000000) {
          return 20;
        }
        return 17;
      default:
        if (isLeader && month > 30000000) {
          return 15;
        }
        return 12;
    }
  }, [isLeader]);

  useEffect(() => {
    async function getSummaryDashboard() {
      setLoading(true);
      const responseDashboard = await dashboardApi.getSummaryDashboard(affID);
      setDataDashboard(responseDashboard?.data?.dashboard);
      setDataDashboardFiltered(responseDashboard?.data?.dashboard);

      setDataPayout(responseDashboard?.data?.payouts);
      setDataPayoutFiltered(responseDashboard?.data?.payouts);

      setDataVisits(responseDashboard?.data?.visits || []);
      setDataVisitsFiltered(responseDashboard?.data?.visits || []);
      setLoading(false);
    }

    getSummaryDashboard();
  }, [setLoading]);

  const dashboardFilterHandler = (dateEntry) => {
    let payoutFilterTmp = [];
    let dashboardFilterTmp = [];
    let visitsFilterTmp = [];
    setFilterDate(dateEntry);

    if (dateEntry.slug !== 'all') {
      const dateRange = {
        startDate: dateEntry.range.startDate,
        endDate: dateEntry.range.endDate
      };

      payoutFilterTmp = dataPayout?.leads.filter(row => {
        return filterRangeDate(dateRange, row.order_date);
      });

      dashboardFilterTmp = dataDashboard?.data.filter(row => {
        return filterRangeDate(dateRange, row.date);
      });

      if (dataVisits.length > 0) {
        visitsFilterTmp = dataVisits.filter(row => {
          return filterRangeDate(dateRange, row.date);
        });
      }
      setDataPayoutFiltered(state => ({
        ...state,
        leads: payoutFilterTmp
      }));
      setDataDashboardFiltered(state => ({
        ...state,
        data: dashboardFilterTmp
      }));
      setDataVisitsFiltered(visitsFilterTmp);
    } else {
      setDataPayoutFiltered(dataPayout);
      setDataDashboardFiltered(dataDashboard);
      setDataVisitsFiltered(dataVisits);
    }
  };

  useEffect( () => {
    if (dataDashboard?.team_data && dataDashboard?.team_data.length) {
      setIsLeader(true);
    }
  }, [dataDashboard, setIsLeader] );

  useEffect(() => {
    let sumTotalEarnings = 0;
    let sumUnPaidEarnings = 0;
    const affiliateUnPayoutMonths = [];
    const affiliatePayoutMonths = [];

    if (dataPayoutFiltered && dataPayoutFiltered.leads) {
      const unpaidReferrals = dataPayoutFiltered.leads.filter(item => {
        return item.status === 'Unpaid';
      }).length;

      const paidReferrals = dataPayoutFiltered.leads.filter(item => {
        return item.status === 'Paid';
      }).length;

      for (let value of dataPayoutFiltered.leads) {
        if (value.status === 'Unpaid') {
          let date = new Date(value.date);
          let month = moment(date).subtract(1, 'month').startOf('month').format('YYYYMMDD');
          if (affiliateUnPayoutMonths[month]) {
            affiliateUnPayoutMonths.push({
              amount: affiliateUnPayoutMonths[month] + value.amount
            });
          } else {
            affiliateUnPayoutMonths.push({
              amount: value.amount
            });
          }
        }
      }

      for (let value of dataPayoutFiltered.leads) {
        let date = new Date(value.date);
        let month = moment(date).subtract(1, 'month').startOf('month').format('YYYYMMDD');
        if (affiliatePayoutMonths[month]) {
          affiliatePayoutMonths.push({
            amount: affiliatePayoutMonths[month] + value.amount
          });
        } else {
          affiliatePayoutMonths.push({
            amount: value.amount
          });
        }
      }

      if (affiliateUnPayoutMonths.length > 0) {
        for (let i = 0; i < affiliateUnPayoutMonths.length; i++) {
          const percent = calcRevenuePercent(dataPayoutFiltered.contract_type, affiliateUnPayoutMonths[i].amount);
          sumUnPaidEarnings += (affiliateUnPayoutMonths[i].amount * percent / 100);
        }
      }

      if (affiliatePayoutMonths.length > 0) {
        for (let i = 0; i < affiliatePayoutMonths.length; i++) {
          const percent = calcRevenuePercent(dataPayoutFiltered.contract_type, affiliatePayoutMonths[i].amount);
          sumTotalEarnings += (affiliatePayoutMonths[i].amount * percent / 100);
        }
      }

      setReferralsCounting(state => ({
        ...state,
        unpaidReferrals,
        paidReferrals,
        unPaidEarning: sumUnPaidEarnings,
        paidEarnings: sumTotalEarnings
      }));
    }

  }, [dataPayoutFiltered, calcRevenuePercent]);

  useEffect(() => {
    let affiliateDashboardMonths = [];
    let isConverted = 0;
    let expectedRevenue = 0;
    let actualRevenue = 0;
    let commissionRevenue = 0;
    let actualCommission = 0;
    let referralsSucceed = 0;

    if (dataDashboardFiltered && dataDashboardFiltered.data) {
      for (let value of dataDashboardFiltered.data) {
        if (value.is_converted === true && value.deal_stage === 'Closed Won') {
          isConverted++;
        }

        if (value.deal_stage === 'Closed Won' || value.deal_stage === 'Proposal') {
          expectedRevenue += value.lead_amount;

          let date = new Date(value.payout_date);
          let month = moment(date).subtract(1, 'month').startOf('month').format('YYYYMMDD');
          if (affiliateDashboardMonths[month]) {
            affiliateDashboardMonths.push({
              amount: affiliateDashboardMonths[month] + value.lead_amount
            });
          } else {
            affiliateDashboardMonths.push({
              amount: value.lead_amount
            });
          }
        }

        if (value.deal_stage === 'Closed Won') {
          actualRevenue += value.lead_amount;
          referralsSucceed++;
          if (affiliateDashboardMonths.length > 0) {
            for (let i = 0; i < affiliateDashboardMonths.length; i++) {
              const percent = calcRevenuePercent(dataDashboardFiltered.contract_type, affiliateDashboardMonths[i].amount);
              actualCommission += (affiliateDashboardMonths[i].amount * percent / 100);
            }
          }
        }
      }

      if (affiliateDashboardMonths.length > 0) {
        for (let i = 0; i < affiliateDashboardMonths.length; i++) {
          const percent = calcRevenuePercent(dataDashboardFiltered.contract_type, affiliateDashboardMonths[i].amount);
          commissionRevenue += (affiliateDashboardMonths[i].amount * percent / 100);
        }
      }
    }

    setReferralsCounting(state => ({
      ...state,
      conversionRate: (Math.round((isConverted / dataDashboardFiltered?.data?.length) * 100) / 10 * 10) || 0,
      expectedRevenue,
      actualRevenue,
      commissionRevenue,
      actualCommission,
      referralsSucceed
    }));
  }, [dataDashboardFiltered, calcRevenuePercent]);

  const filterRangeDate = (dateRange, entryDate) => {
    let filterPass = true;
    const date = moment(entryDate).unix();
    if (dateRange.startDate) {
      filterPass = filterPass && (dateRange.startDate <= date);
    }
    if (dateRange.endDate) {
      filterPass = filterPass && (dateRange.endDate >= date);
    }
    return filterPass;
  };

  return (
    <div className="page-home container-fluid">
      <div className="d-flex justify-content-end align-items-baseline mb-3">
        <div className="d-flex align-items-center">
          <FilterDate
            onSelectDate={dashboardFilterHandler}
          />
          <ExportToExcel
            dateFilter={filterDate}
            fileName={filterDate.slug}
          />
        </div>
      </div>

      <hr />

      <h1 className="welcome-message">Xin chào, {userProfile.display_name}!</h1>

      <section className="section-card">
        <h2 className="section-card__title">Lượt giới thiệu</h2>
        <div className="section-card__body">
          <div className="row">
            <div className="col-lg-3">
              <CardHome
                iconName="click"
                title="Lượt truy cập"
                text={dataVisitsFiltered ? dataVisitsFiltered.length : 0}
                link="/visits"
                tooltip="Thể hiện số lượng truy cập khi người khác nhấp vào link bạn chia sẻ"
              />
            </div>

            <div className="col-lg-3">
              <CardHome
                iconName="click"
                title="Lượt giới thiệu"
                text={dataPayoutFiltered?.leads?.length || 0}
                link="/referrals"
                tooltip="Thể hiện số lượng đơn hàng đăng ký mua ELSA qua link affiliate của bạn"
              />
            </div>

            <div className="col-lg-3">
              <CardHome
                iconName="click"
                title="Lượt giới thiệu thành công"
                text={referralsCounting.referralsSucceed}
                link="/referrals/#succeed"
                tooltip="Thể hiện số lượng đơn hàng đã thanh toán thành công qua link affiliate của bạn"
              />
            </div>

            <div className="col-lg-3">
              <CardHome
                iconName="balance"
                title="Tỷ lệ chuyển đổi"
                text={referralsCounting.conversionRate + ' %'}
                link="#"
                tooltip="Thể hiện tỉ lệ chuyển đổi từ đơn hàng đăng ký sang đơn hàng thanh toán thành công"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section-card">
        <h2 className="section-card__title">Doanh thu sản phẩm</h2>
        <div className="section-card__body">
          <div className="row">
            <div className="col-lg-6 col-xl-3">
              <CardHome
                iconName="coin"
                title="Doanh thu dự kiến"
                text={referralsCounting.expectedRevenue.toLocaleString() + ' đ'}
                tooltip="Thể hiện hoa hồng từ những đơn hàng đang xác nhận thanh toán và những người dùng đã thanh toán thành công"
              />
            </div>

            <div className="col-lg-6 col-xl-3">
              <CardHome
                iconName="coin"
                title="Doanh thu thực tế"
                text={referralsCounting.actualRevenue.toLocaleString() + ' đ'}
                tooltip="Thể hiện doanh thu chỉ bao gồm đơn hàng đã thanh toán thành công"
              />
            </div>

            <div className="col-lg-6 col-xl-3">
              <CardHome
                iconName="coin"
                title="Hoa hồng dự kiến"
                text={referralsCounting.commissionRevenue.toLocaleString() + ' đ'}
                tooltip="Thể hiện hoa hồng từ những đơn hàng đang xác nhận thanh toán và đơn hàng đã thanh toán thành công"
              />
            </div>

            <div className="col-lg-6 col-xl-3">
              <CardHome
                iconName="coin"
                title="Hoa hồng thực tế"
                text={referralsCounting.actualCommission.toLocaleString() + ' đ'}
                tooltip="Thể hiện hoa hồng từ những đơn hàng đã thanh toán thành công"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section-card">
        <h2 className="section-card__title">Thanh toán</h2>
        <div className="section-card__body">
          <div className="row">
            <div className="col-lg-4">
              <CardHome
                iconName="click"
                title="Lượt giới thiệu ELSA chưa thanh toán"
                text={referralsCounting.unpaidReferrals}
                tooltip="Thể hiện lượt giới thiệu thành công mà ELSA chưa thanh toán cho Affiliate"
              />
            </div>

            <div className="col-lg-4">
              <CardHome
                iconName="click"
                title="Lượt giới thiệu ELSA đã thanh toán"
                text={referralsCounting.paidReferrals}
                tooltip="Thể hiện lượt giới thiệu thành công mà ELSA đã thanh toán cho Affiliate"
              />
            </div>

            <div className="col-lg-4">
              <CardHome
                iconName="click"
                title="Tổng lượt giới thiệu thành công"
                text={referralsCounting.paidReferrals + referralsCounting.unpaidReferrals}
                tooltip="Thể hiện tất cả lượt giới thiệu thành công mà ELSA chưa thanh toán và đã thanh toán cho Affiliate"
              />
            </div>

            <div className="col-lg-4">
              <CardHome
                iconName="coin"
                title="Hoa hồng chưa thanh toán"
                text={referralsCounting.actualCommission.toLocaleString() + ' đ'}
                tooltip="Thể hiện hoa hồng cho những đơn hàng thành công mà ELSA chưa thanh toán cho Affiliate"
              />
            </div>

            <div className="col-lg-4">
              <CardHome
                iconName="coin"
                title="Hoa hồng đã thanh toán"
                text={referralsCounting.paidEarnings.toLocaleString() + ' đ'}
                tooltip="Thể hiện hoa hồng cho những đơn hàng thành công mà ELSA đã thanh toán cho Affiliate"
              />
            </div>

            <div className="col-lg-4">
              <CardHome
                iconName="coin"
                title="Tổng hoa hồng"
                text={(referralsCounting.paidEarnings + referralsCounting.unPaidEarning).toLocaleString() + ' đ'}
                tooltip="Thể hiện tổng hoa hồng cho các đơn hàng thành công mà ELSA chưa thanh toán và đã thanh toán cho Affiliate"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home;
